const { getElement, getElements } = window.BAO.Utils

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.updateParentHeights()
  }

  setupListeners () {
    super.setupListeners()

    if (
      document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      document.addEventListener(
        'click',
        this.handleToggleButtonClick.bind(this),
      )
    }

    document.addEventListener('focusin', this.handleFocusIn.bind(this))

    document.addEventListener('keyup', this.handleEscapePress.bind(this))

    this.handleChildButtonClick = this.handleChildButtonClick.bind(this)

    this.listeners.add(this, 'click', this.handleChildButtonClick)
  }

  updateParentHeights () {
    const allItems = this.els.item?.elements

    if (!allItems || !allItems.length) return

    allItems.forEach((item) => {
      const childItems = getElements(this.els['child-items'].selector, {
        context: item,
      })

      if (!childItems.length) return

      let maxHeight = 0
      childItems.forEach((child) => {
        const childHeight = child.getBoundingClientRect().height
        if (childHeight > maxHeight) {
          maxHeight = childHeight
        }
      })

      const body = getElement(this.els.body.selector, { context: item })
      if (body) {
        body.style.minHeight = `${maxHeight}px`
      }
    })
  }

  handleChildButtonClick (event) {
    if (!event.target.closest(this.els?.['child-button']?.selector)) return

    const closestItem = event.target.closest(this.els?.item?.selector)

    const childItems = getElement(this.els['child-items'].selector, {
      context: closestItem,
    })

    const allChildItems = getElements(this.els['child-items'].selector)
    const allChildButtons = getElements(this.els['child-button'].selector)

    allChildItems.forEach((item) => {
      if (item !== childItems) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    allChildButtons.forEach((button) => {
      button.classList.remove('active')
      button.setAttribute('aria-expanded', 'false')
    })

    const currentState = childItems.getAttribute('aria-hidden') === 'true'
    childItems.setAttribute('aria-hidden', !currentState)

    const childButton = event.target.closest(this.els['child-button'].selector)
    if (childButton) {
      childButton.classList.toggle('active', currentState)
      childButton.setAttribute('aria-expanded', currentState)
    }
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (!this.els?.['menu-dropdown-toggle']?.exists) return

    if (!event.target.closest(this.els?.['menu-dropdown-toggle'].selector)) {
      return
    }

    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })

    if (!menuDropdownEl) return

    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')
    } else {
      menuToggleEl.setAttribute('data-active', 'true')
      menuDropdownEl.setAttribute('aria-expanded', 'true')
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('data-active')
      })
    }

    if (this.els?.['menu-dropdown']?.exists) {
      this.els?.['menu-dropdown']?.elements.forEach((menuDropdownEl) => {
        menuDropdownEl.removeAttribute('aria-expanded')
      })
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
